import React, { Component } from "react";
import { IoIosAddCircle, IoIosCalendar, IoIosAlbums } from "react-icons/io";

import ClinicsForm from "./ClinicsForm";
import ServicesLine from "../shared/ServicesLine";
import Trending from "../shared/Trending";

 class MainClinics extends Component {
  state={
    servicesList: [
      {
        title: "اكثر من 200 شركة",
        desc: "يوجد لدينا ابرز الشركات المتخصصة في الأفراح والمناسبات",
        Icon: IoIosAddCircle,
      },
      {
        title: "اكثر من 200 شركة",
        desc: "يوجد لدينا ابرز الشركات المتخصصة في الأفراح والمناسبات",
        Icon: IoIosCalendar,
      },
      {
        title: "اكثر من 200 شركة",
        desc: "يوجد لدينا ابرز الشركات المتخصصة في الأفراح والمناسبات",
        Icon: IoIosAlbums,
      },
    ],
   }
  render() {
    return (
      <>
      <div className={`large-hero ${this.props.small&& "large-hero--small"}`}>
        <img
          src={`${process.env.PUBLIC_URL}/images/clinics-bg.jpg`}
          alt="خلفية لقسم حجز الحفلات في اليمن"
          className={`large-hero__image`}
        />
        <div className="large-hero__overlay"></div>
        <div className="large-hero__content">
          <div className="wrapper">
          {!this.props.small &&  <>  <h1 className="large-hero__title">موعدك مع دكتورك اصبج سهل الحجز</h1>
         
          <h2 className="large-hero__subtitle">اختار دكتورك المناسب وعربنه بأقل الأسعار</h2>
           </>}
            <div className="container container__not-hidden">
            <ClinicsForm/>
            </div>
          </div>
        </div>
      </div>
      <ServicesLine list={this.state.servicesList} />
      <Trending badge="" type='clinicsProducts'/>

</>
    );
  }
}



export default MainClinics;

